import { useState, useRef, useEffect } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const natpis = { fontWeight: "bold", fontSize: "14px", marginBottom: "5px" };
const inputStyle = {
  fontSize: "14px",
  height: "40px",
  padding: "0 8px",
  width: "100%",
  boxSizing: "border-box",
};

const getSixMonthsLater = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return "";
  let day = parseInt(parts[0]);
  let month = parseInt(parts[1]);
  let year = parseInt(parts[2]);
  let newMonth = month + 6;
  if (newMonth > 12) {
    newMonth -= 12;
    year += 1;
  }
  return `${String(day).padStart(2, "0")}.${String(newMonth).padStart(2, "0")}.${year}.`;
};

const formatDateForApi = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return null;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

function InstalacijaCombobox({ instalacije, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const filtered = instalacije.filter((i) =>
    i.naziv.toLowerCase().includes(filter.toLowerCase()),
  );

  const handleInput = (e) => {
    setFilter(e.target.value);
    onChange(e.target.value, null); // novi naziv, nema id
    setOpen(true);
  };

  const handleSelect = (inst) => {
    setFilter(inst.naziv);
    onChange(inst.naziv, inst.instalacija_id);
    setOpen(false);
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "white",
    border: "1px solid #ccc",
    zIndex: 1000,
    maxHeight: "200px",
    overflowY: "auto",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  };

  const optionStyle = (hovered) => ({
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    backgroundColor: hovered ? "#e0e0e0" : "white",
  });

  return (
    <div ref={ref} style={{ position: "relative", width: "20vw" }}>
      <div style={natpis}>INSTALACIJA</div>
      <div style={{ position: "relative" }}>
        <input
          value={filter}
          onChange={handleInput}
          onFocus={() => setOpen(true)}
          style={{ ...inputStyle, paddingRight: "30px" }}
          placeholder="Odaberi ili unesi novi..."
        />
        <div
          onClick={() => setOpen((o) => !o)}
          style={{
            position: "absolute",
            right: "8px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "12px",
            color: "#666",
            userSelect: "none",
          }}
        >
          ▼
        </div>
      </div>

      {open && (
        <div style={dropdownStyle}>
         
          {filtered.map((inst) => (
            <InstalacijaOption
              key={inst.instalacija_id}
              inst={inst}
              onSelect={handleSelect}
              optionStyle={optionStyle}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function InstalacijaOption({ inst, onSelect, optionStyle }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      style={optionStyle(hovered)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onMouseDown={() => onSelect(inst)}
    >
      {inst.naziv}
    </div>
  );
}

function EvidencijeObrazac9Dodavanje({
  setIsDodavanje,
  onRefresh,
  instalacije,
}) {
  const [naziv, setNaziv] = useState("");
  const [selectedInstalacijaId, setSelectedInstalacijaId] = useState(null);
  const [pregled, setPregled] = useState({
    broj_nalaza: "",
    datum_pregleda: nowDate,
    datum_sledeceg: getSixMonthsLater(nowDate),
    napomena: "",
  });

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  const handleNazivChange = (val, id) => {
    setNaziv(val);
    setSelectedInstalacijaId(id);
  };

  const handleDatumChange = (v) => {
    setPregled((prev) => ({
      ...prev,
      datum_pregleda: v,
      datum_sledeceg: getSixMonthsLater(v),
    }));
  };

  const handleSacuvaj = async () => {
    try {
      let instalacija_id = selectedInstalacijaId;

      if (!instalacija_id) {
        // Nova instalacija
        const { data: resInst } = await axios.post(
          `${baseUrl}/evidencija9/create.php`,
          { company_id: selectedMainEntity.company_id, naziv },
        );
        if (resInst.status !== 200) return;
        instalacija_id = resInst.id;
      }

      const { data: resPregled } = await axios.post(
        `${baseUrl}/evidencija9/createPregled.php`,
        {
          instalacija_id,
          broj_nalaza: pregled.broj_nalaza,
          datum_pregleda: formatDateForApi(pregled.datum_pregleda),
          datum_sledeceg: formatDateForApi(pregled.datum_sledeceg),
          napomena: pregled.napomena,
        },
      );

      if (resPregled.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const isDisabledSacuvaj = !naziv || !pregled.broj_nalaza;

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
        <InstalacijaCombobox
          instalacije={instalacije}
          value={naziv}
          onChange={handleNazivChange}
        />

        <div style={{ width: "12vw" }}>
          <div style={natpis}>БРОЈ НАЛАЗА</div>
          <input
            value={pregled.broj_nalaza}
            onChange={(e) =>
              setPregled((p) => ({ ...p, broj_nalaza: e.target.value }))
            }
            style={inputStyle}
          />
        </div>

        <div>
          <div style={natpis}>ДАТУМ ПРЕГЛЕДА</div>
          <CustomCalendarInput
            value={pregled.datum_pregleda}
            onChange={handleDatumChange}
          />
        </div>

        <div>
          <div style={natpis}>СЛЕДЕЋИ ПРЕГЛЕД</div>
          <CustomCalendarInput
            value={pregled.datum_sledeceg}
            onChange={(v) => setPregled((p) => ({ ...p, datum_sledeceg: v }))}
          />
        </div>

        <div style={{ flex: 1 }}>
          <div style={natpis}>НАПОМЕНА</div>
          <input
            value={pregled.napomena}
            onChange={(e) =>
              setPregled((p) => ({ ...p, napomena: e.target.value }))
            }
            style={inputStyle}
          />
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={() => setIsDodavanje(false)}>
            <Button activation={true} style={styles.button}>
              ОДУСТАНИ
            </Button>
          </div>
          <div
            onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
            style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
          >
            <Button
              isDisabled={isDisabledSacuvaj}
              activation={true}
              style={styles.button}
            >
              САЧУВАЈ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac9Dodavanje;
